import { DayOfWeekSchedule } from "../../product/enums";
import { MenuScheduleSettings } from "./menu.schedule.model";
import { DocumentData } from "@angular/fire/firestore";
import { StringTimeframeBuilder } from "../../timeframe/string-timeframe.builder";
import { StringTimeframe } from "../../timeframe/string-timeframe.model";
import { HoursOfOperation } from '../hours.model';

export class MenuScheduleSettingsBuilder {
  private _dow: DayOfWeekSchedule;
  private _hours: WeeklyHoursOfOperation;
  private _availability: StringTimeframeBuilder;
  private _blackout: StringTimeframeBuilder[];

  constructor(private readonly timezone: string) {
    this.default();
  }

  public get dow(): DayOfWeekSchedule {
    return this._dow;
  }
  public set dow(dow: DayOfWeekSchedule) {
    this._dow = dow;
  }

  public get availability(): StringTimeframeBuilder {
    return this._availability;
  }
  public set availability(a: StringTimeframeBuilder) {
    this._availability = a;
  }

  public get blackout(): StringTimeframeBuilder[] {
    return this._blackout;
  }
  public set blackout(s: StringTimeframeBuilder[]) {
    this._blackout = s;
  }
  public get hours(): WeeklyHoursOfOperation {
    return this._hours;
  }

  public default(): void {
    //DONE: INITIALIZE DEFAULT VALUES;
    this._dow = new DayOfWeekSchedule({
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true
    });
    this._hours = new WeeklyHoursOfOperation();
    this._availability = new StringTimeframeBuilder(this.timezone);
    this._blackout = [];
  }

  public load(data: DocumentData): MenuScheduleSettingsBuilder {
    this._availability.load(data.availability);
    this._blackout = data.blackout.map((data: DocumentData) =>
      new StringTimeframeBuilder(this.timezone).load(data)
    );
    this._hours = data.hours == null ? new WeeklyHoursOfOperation() : new WeeklyHoursOfOperation().load(data.hours);
    this._dow = new DayOfWeekSchedule(data.dow);
    return this;
  }

  public edit(data: MenuScheduleSettings): MenuScheduleSettingsBuilder {
    this._availability.edit(data.availability);
    this._blackout = data.blackout.map((data: StringTimeframe) =>
      new StringTimeframeBuilder(this.timezone).edit(data)
    );
    this._dow = data.dow;
    this._hours = data.hours == null ? new WeeklyHoursOfOperation() : new WeeklyHoursOfOperation().edit(data.hours);
    return this;
  }

  public build(): MenuScheduleSettings {
    return new MenuScheduleSettings(this);
  }

  public toJSON = () => ({
    dow: this.dow.toJSON(),
    availability: this.availability.toJSON(),
    blackout: this.blackout.map(sf => sf.toJSON()),
    hours: this.hours.toJSON()
  });
}

export class WeeklyHoursOfOperation {
  monday: HoursOfOperation;
  tuesday: HoursOfOperation;
  wednesday: HoursOfOperation;
  thursday: HoursOfOperation;
  friday: HoursOfOperation;
  saturday: HoursOfOperation;
  sunday: HoursOfOperation;
  public get asList(): HoursOfOperation[] {
    return [this.monday, this.tuesday, this.wednesday, this.thursday, this.friday, this.saturday, this.sunday];
  }
  public toJSON = () => ({
    monday: this.monday.toJSON(),
    tuesday: this.tuesday.toJSON(),
    wednesday: this.wednesday.toJSON(),
    thursday: this.thursday.toJSON(),
    friday: this.friday.toJSON(),
    saturday: this.saturday.toJSON(),
    sunday: this.sunday.toJSON(),
  });
  constructor() {
    this._default();
  }
  private _default() {
    this.monday = new HoursOfOperation();
    this.tuesday = new HoursOfOperation();
    this.wednesday = new HoursOfOperation();
    this.thursday = new HoursOfOperation();
    this.friday = new HoursOfOperation();
    this.saturday = new HoursOfOperation();
    this.sunday = new HoursOfOperation();
  }

  public load(data: DocumentData) {
    this.monday = new HoursOfOperation().load(data.monday);
    this.tuesday = new HoursOfOperation().load(data.tuesday);
    this.wednesday = new HoursOfOperation().load(data.wednesday);
    this.thursday = new HoursOfOperation().load(data.thursday);
    this.friday = new HoursOfOperation().load(data.friday);
    this.saturday = new HoursOfOperation().load(data.saturday);
    this.sunday = new HoursOfOperation().load(data.sunday);
    return this;
  }

  public edit(hours: WeeklyHoursOfOperation) {
    this.monday = new HoursOfOperation().edit(hours.monday);
    this.tuesday = new HoursOfOperation().edit(hours.tuesday);
    this.wednesday = new HoursOfOperation().edit(hours.wednesday);
    this.thursday = new HoursOfOperation().edit(hours.thursday);
    this.friday = new HoursOfOperation().edit(hours.friday);
    this.saturday = new HoursOfOperation().edit(hours.saturday);
    this.sunday = new HoursOfOperation().edit(hours.sunday);
    return this;
  }

  public setMonday(range: number[]) {
    this.monday = new HoursOfOperation().set(range);
  }
  public setTuesday(range: number[]) {
    this.tuesday = new HoursOfOperation().set(range);

  }
  public setWednesday(range: number[]) {
    this.wednesday = new HoursOfOperation().set(range);
  }
  public setThursday(range: number[]) {
    this.thursday = new HoursOfOperation().set(range);
  }
  public setFriday(range: number[]) {
    this.friday = new HoursOfOperation().set(range);
  }
  public setSaturday(range: number[]) {
    this.saturday = new HoursOfOperation().set(range);
  }
  public setSunday(range: number[]) {
    this.sunday = new HoursOfOperation().set(range);
  }

}

